<script setup lang="ts">
import { ref, reactive, watch } from 'vue';
import appConfig from '@/app.config.json'

const props = defineProps<{
  usuarioId?: number | string
  alt?: string
}>()

var controle = reactive({
  usuarioId: props.usuarioId,
  erro: false,
  src: props.usuarioId ? `${appConfig.urlApi}/Fotos/Usuarios/${props.usuarioId}.png` : ""
})

watch(() => props.usuarioId, (newVal) => {
  controle.usuarioId = newVal;
  console.log("UsuarioId atualizado:", controle.usuarioId);
  controle.src = controle.usuarioId ? `${appConfig.urlApi}/Fotos/Usuarios/${controle.usuarioId}.png` : "";
}, { immediate: true })


const imgUrl = new URL('@/assets/images/user/sem-imagem-usuario.jpg', import.meta.url).href

function onError(e: Event) {
  const el = e.target as HTMLImageElement;
  controle.erro = true;
  el.src = imgUrl;
}


</script>

<template>
  <img :src="controle.src" :alt="alt" class="rounded-circle me-2" width="32" height="32" style="object-fit:cover;"
    @error="onError" />
</template>
